import { HTTPService } from "./http.service";
import { AssessmentGroup } from "../models/assessment-group";
import { ManagedClient } from "../models/managed-client";
import { AssignmentHydratorService } from "./assignment-hydrator.service";
import { AssessmentTokenService } from "./assessment-token.service";
import { AssignedAssessmentGroup } from "../models/AssignedAssessmentGroup";
import { Assignment } from "../models/Assignment";
import { AssignedAssessment } from "../models/AssignedAssessment";
import { Injectable } from "@angular/core";

@Injectable()
export class AssignmentService {
    constructor(private _dac$http: HTTPService
        ,private assignmentHydrator:AssignmentHydratorService) {

    }

    createClientGroupAssignment(client: ManagedClient, group: AssessmentGroup) : Promise<Assignment> {
		return this._dac$http.post("/clients/" + client.id + "/assignment-groups/", {id: group.Id})
			.then((serverResponse) => {
				let response = serverResponse.json() as any;
                let serverAssignment = this.assignmentHydrator.hydrateAssignment(response.assignment) as AssignedAssessmentGroup;
				return serverAssignment;
			});
	}

	saveClientAssignment(client: ManagedClient, assignment: Assignment) : Promise<Assignment> {
		if (assignment.Id) {
			return this.updateClientAssignment(client, assignment);
		}
		else {
			return this.createClientAssignment(client, assignment);
		}
	}
	removeClientAssignment(client: ManagedClient, assignment: Assignment)  : Promise<Assignment> {
		return this._dac$http.delete("/clients/" + client.id + "/assignments/" + assignment.Id).then((response) => {
			return response;
		});
    }
    private createClientAssignment(client: ManagedClient, assignment: Assignment) : Promise<Assignment> {
		return this._dac$http.post("/clients/" + client.id + "/assignments/", assignment)
			.then((serverResponse) => {
				let response = serverResponse.json() as any;
				let serverAssignment = this.assignmentHydrator.hydrateAssignment(response.assignment) as Assignment;
				return serverAssignment;
			});
		// TODO: stephen need to handle errors here.
	}

	private updateClientAssignment(client: ManagedClient, assignment: Assignment) : Promise<Assignment> {
		return this._dac$http.post("/clients/" + client.id + "/assignments/" + assignment.Id, assignment)
			.then((serverResponse) => {
				// TODO: stephen anything we need to do w/ the server response?
				return assignment;
			});
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/services/assignment.service.ts